module.exports = __webpack_public_path__ + "static/media/hf-logo.cfa64941.png";